/* HURRICANE theme — assets/site.js + assets/js/track.js + assets/js/permalink.js + assets/js/dock-rules.js + assets/js/bag.js + assets/js/dock.js. Generated by _build/theme/pack.mjs from the static site's own JS. */
(function () {
'use strict';
var d = document, h = d.documentElement, W = window;
var CFG = W.HRC_CFG || {};
var mm = function (q) { try { return W.matchMedia(q).matches; } catch (e) { return false; } };
var RM = mm('(prefers-reduced-motion: reduce)');
var FINE = mm('(pointer:fine)');
var MOTION = !RM && FINE; // v7 meaning: fine pointer and no reduced motion
var $ = function (s, r) { return (r || d).querySelector(s); };
var $$ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
var mem = {};
function store(kind) {
return {
get: function (k) { try { return W[kind].getItem(k); } catch (e) { return mem[kind + k] == null ? null : mem[kind + k]; } },
set: function (k, v) { try { if (v == null) W[kind].removeItem(k); else W[kind].setItem(k, v); } catch (e) { mem[kind + k] = v; } },
json: function (k) { try { return JSON.parse(this.get(k) || 'null'); } catch (e) { return null; } },
};
}
var ls = store('localStorage'), ss = store('sessionStorage');
var HRC = W.HRC = {
RM: RM, FINE: FINE, MOTION: MOTION, $: $, $$: $$, cfg: CFG, t: CFG.t || {}, ls: ls, ss: ss,
root: h.getAttribute('data-root') || '',
money: function (n) { return '$' + (n % 1 ? n.toFixed(2) : n); },
fmt: function (s, v) { return String(s || '').replace(/\$\{(\w+)\}/g, function (m, k) { return k in v ? '$' + v[k] : m; }).replace(/\{(\w+)\}/g, function (m, k) { return k in v ? v[k] : m; }); },
emit: function (n, detail) { try { d.dispatchEvent(new CustomEvent('hrc:' + n, { detail: detail })); } catch (e) {} },
on: function (n, fn) { d.addEventListener('hrc:' + n, function (e) { fn(e.detail); }); },
url: function (p) { return /^(https?:|\/)/.test(p) ? p : HRC.root + p; },
vurl: function (p, v) { return HRC.url(p.url) + (p.single || !v ? '' : v.s ? '?scent=' + v.s : '?variant=' + v.id); },
};
function conn() { try { return navigator.connection || null; } catch (e) { return null; } }
function lowData() {
var c = conn();
try { return !!(c && (c.saveData || /(^|-)2g$/.test(String(c.effectiveType || '')))); } catch (e) { return false; }
}
HRC.saveData = lowData();
HRC.slowNet = (function () { var c = conn(); try { return !!(c && /(^|-)[23]g$/.test(String(c.effectiveType || ''))); } catch (e) { return false; } })();
HRC.paused = ls.get('hrc.motion') === 'paused';
function baseMode() {
if (RM || HRC.paused || HRC.saveData) return 'still';
var c = ss.get('hrc.motionMode');
return c === 'video' ? c : null;
}
HRC.setMotionMode = function (m) {
HRC.motionMode = m;
if (m === 'video') ss.set('hrc.motionMode', m);
h.classList.toggle('motion-still', m === 'still');
h.classList.toggle('motion-frames', m === 'frames');
h.classList.toggle('motion-video', m === 'video');
HRC.emit('motionmode', m);
};
HRC.setMotionMode(baseMode());
var clips = [];
HRC.media = {
plate: null,
register: function (v) { if (clips.indexOf(v) < 0) clips.push(v); },
play: function (v) {
clips.forEach(function (o) { if (o !== v && !o.paused) { try { o.__ours = true; o.pause(); } catch (e) {} } });
if (HRC.media.plate && v !== HRC.media.plate && !HRC.media.plate.paused) HRC.media.plate.pause();
try { var p = v.play(); return p && p.then ? p : Promise.resolve(); } catch (e) { return Promise.reject(e); }
},
anyPlaying: function () { return clips.some(function (o) { return !o.paused && o !== HRC.media.plate; }); },
idle: function () { if (!HRC.media.anyPlaying()) HRC.emit('media-idle'); },
};
var wakes = [], WAKE_EV = ['touchend', 'click', 'keydown'], wakeOn = false;
function onGesture() {
var list = wakes; wakes = [];
list.forEach(function (f) { try { f(); } catch (e) {} });
if (!wakes.length && wakeOn) { wakeOn = false; WAKE_EV.forEach(function (t) { d.removeEventListener(t, onGesture, true); }); }
}
HRC.wake = function (fn) {
if (wakes.indexOf(fn) < 0) wakes.push(fn);
if (!wakeOn) { wakeOn = true; WAKE_EV.forEach(function (t) { d.addEventListener(t, onGesture, { capture: true, passive: true }); }); }
};
HRC.clip = function (v, opts) {
opts = opts || {};
if (!v || v.__hrc) return;
v.__hrc = true;
HRC.media.register(v);
v.muted = true; v.defaultMuted = true; v.playsInline = true;
v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
var visible = false, ratio = 0, failed = false, refused = false, need = opts.threshold || 0.25;
function src() { return opts.src ? opts.src() : v.getAttribute('data-src'); }
function fail(e) {
failed = true;
refused = !!(e && e.name === 'NotAllowedError');
try { if (!v.paused) { v.__ours = true; v.pause(); } } catch (x) {}
v.removeAttribute('src'); try { v.load(); } catch (x) {}
v.classList.remove('on');
h.classList.add('no-autoplay');
if (opts.probe || HRC.motionMode == null) HRC.setMotionMode('frames');
if (opts.onFail) opts.onFail();
if (refused) HRC.wake(wake);
}
function wake() {
if (failed && !refused) return;
if (HRC.motionMode === 'still' || v.__userPaused) return;
if (!visible || d.hidden || (opts.hold && opts.hold())) { HRC.wake(wake); return; }
failed = refused = false;
v.__wokeAt = Date.now();                               // (the click of this gesture must not toggle it off again)
if (!v.getAttribute('src')) { v.setAttribute('src', src()); v.preload = 'auto'; }
HRC.media.play(v).then(function () {
h.classList.remove('no-autoplay');
if (HRC.motionMode !== 'video') HRC.setMotionMode('video');
}, function (e) { if (!e || e.name !== 'AbortError') fail(e); });
}
v.addEventListener('playing', function () {
v.classList.add('on');
if (HRC.motionMode == null) HRC.setMotionMode('video');
if (opts.onPlaying) opts.onPlaying();
});
function tryPlay() {
if (failed || !visible || d.hidden || v.__userPaused) return;
if (!v.paused && v.getAttribute('src')) return;
var m = HRC.motionMode;
if (m === 'still') return;
if (m === 'frames') { HRC.wake(wake); return; }
if (m == null && !opts.probe && !opts.follower) return;
if (!v.getAttribute('src')) { if (ratio < need - 0.001) return; v.setAttribute('src', src()); v.preload = 'auto'; }
if (opts.hold && opts.hold()) return;
HRC.media.play(v).then(function () {}, function (e) { if (!e || e.name !== 'AbortError') fail(e); });
}
function stop() { try { if (!v.paused) { v.__ours = true; v.pause(); } } catch (e) {} HRC.media.idle(); }
v.addEventListener('pause', function () {
if (v.__ours) { v.__ours = false; return; }          // (set before each of our own pauses; the event comes later)
if (!v.loop) return;
setTimeout(function () {
if (!v.paused || failed || !visible || d.hidden || v.__userPaused || HRC.media.anyPlaying()) return;
if (HRC.motionMode !== 'video' && !(HRC.motionMode == null && opts.probe)) return;
if (opts.hold && opts.hold()) return;
HRC.media.play(v).then(function () {}, function () {});
}, 0);                                                   // (every pauser sets its flag in the pause's own task)
});
v.addEventListener('ended', function () { if (v.loop && !failed) { try { v.currentTime = 0; } catch (e) {} tryPlay(); } });
if ('IntersectionObserver' in W) {
new IntersectionObserver(function (es) {
es.forEach(function (e) { visible = e.isIntersecting; ratio = e.intersectionRatio; if (visible) tryPlay(); else stop(); });
}, { threshold: need }).observe(opts.observe || v);
}
d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); else tryPlay(); });
HRC.on('motionmode', function (m) { if (m === 'still') { stop(); v.classList.remove('on'); } else if (m !== 'frames') tryPlay(); });
return { play: tryPlay, stop: stop, el: v, get failed() { return failed; } };
};
function afterPaint(fn) {
var idle = function () { (W.requestIdleCallback || function (f) { return setTimeout(f, 0); })(fn, { timeout: 1200 }); };
var run = function () {
try {
if (performance.getEntriesByType('paint').length) return idle();
var po = new PerformanceObserver(function () { po.disconnect(); idle(); });
po.observe({ type: 'paint', buffered: true });
} catch (e) { idle(); }
};
if (d.readyState === 'complete') run(); else W.addEventListener('load', run, { once: true });
}
HRC.afterPaint = afterPaint;
(function () {
var door = $('[data-door]'), n = door && $('[data-door-n]', door), w = door && $('.door__w', door);
if (!n || !w || /(^|\s)(door-q|no-door|rm|motion-paused|motion-still)(\s|$)/.test(h.className) || getComputedStyle(door).display === 'none') return;
var v = 0, ready = false, now = function () { return performance.now(); };
function show() { n.textContent = v < 10 ? '0' + v : String(v); w.style.setProperty('--load', (v / 100).toFixed(3)); }
if (h.classList.contains('door-ad')) {
var iv0 = setInterval(function () { v = Math.min(100, Math.floor(now() / 6)); show(); if (v >= 100) clearInterval(iv0); }, 20);
return;
}
if (now() > 2300) { v = 100; show(); return; }
var pic = $('img[fetchpriority="high"]');
Promise.all([d.fonts && d.fonts.ready ? d.fonts.ready : 0, pic ? (pic.decode ? pic.decode() : 0) : 0])
.then(function () { ready = true; }, function () { ready = true; });
var iv = setInterval(function () {
var goal = ready ? 100 : 92;
v = Math.min(goal, v + Math.max(1, Math.round((goal - v) * 0.11)));
if (now() >= 2400) v = 100;
show();
if (v < 100) return;
clearInterval(iv);
setTimeout(function () { h.classList.add('door-go'); HRC.emit('door', 'go'); }, 260);
}, 37);
})();
HRC.doorOpen = function (fn) {
var door = $('[data-door]'), done = false;
var go = function () { if (!done) { done = true; fn(); } };
if (!door || getComputedStyle(door).display === 'none' || h.classList.contains('door-go')) { go(); return; }
if (h.classList.contains('door-q')) { setTimeout(go, 380); return; }
if (h.classList.contains('door-ad')) { setTimeout(go, 600); return; }
HRC.on('door', go);
setTimeout(go, 2700);
};
var doorOff = function () { return !$('[data-door]') || /(^|\s)(no-door|rm|motion-paused|motion-still)(\s|$)/.test(h.className); };
var vtDocs = 'onpageswap' in W;   // test hook: behave as a browser without them
W.addEventListener('pageswap', function (e) {
var t = e.viewTransition;
if (t && (!vtDocs || doorOff() || (e.activation && e.activation.navigationType === 'traverse'))) t.skipTransition();
});
W.addEventListener('click', function (e) {   // on window: every other click handler has had its say
if (vtDocs || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || doorOff()) return;
var a = e.target.closest ? e.target.closest('a[href]') : null;
if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
e.preventDefault();
h.classList.add('door-exit');
setTimeout(function () { location.href = u.href; }, 280);
setTimeout(function () { h.classList.remove('door-exit'); }, 8000);   // a navigation that never left the page
});
W.addEventListener('pageshow', function (e) { if (e.persisted) h.classList.remove('door-exit'); });
var FOCUS_M = 0.05;
function focusOne(im) {
var st = im.style, b = (im.getAttribute('data-box') || '').split(' ').map(Number);
st.objectFit = ''; st.objectPosition = ''; st.backgroundColor = '';
var fw = im.offsetWidth, fh = im.offsetHeight;
if (b.length !== 4 || !fw || !fh || getComputedStyle(im).objectFit !== 'cover') return;
var nw = im.naturalWidth || +im.getAttribute('width'), nh = im.naturalHeight || +im.getAttribute('height');
if (!nw || !nh) return;
var s = Math.max(fw / nw, fh / nh), z = im.closest('.kb') ? 1.06 : 1;
var ok = true, pos = [0, 1].map(function (ax) {
var Wn = Math.min(1, ax ? fh / (nh * s) : fw / (nw * s)), Wv = Wn / z, lo = b[ax], hi = b[ax + 2];
var u0 = Wn > 0.999 ? 0 : Math.min(1 - Wn, Math.max(0, (lo + hi) / 2 - Wn / 2));   // the window, then what the zoom leaves of it
var v0 = u0 + (Wn - Wv) / 2, v1 = v0 + Wv;
if ((v0 > 0.001 && (lo - v0) / Wv < FOCUS_M) || (v1 < 0.999 && (v1 - hi) / Wv < FOCUS_M)) ok = false;
return Wn > 0.999 ? 50 : u0 / (1 - Wn) * 100;
});
var bg = im.getAttribute('data-bg');
if (!ok && bg) { st.objectFit = 'contain'; st.backgroundColor = bg; return; }
st.objectPosition = pos[0].toFixed(2) + '% ' + pos[1].toFixed(2) + '%';
}
var focusRO = W.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { focusOne(e.target); }); }) : null;
HRC.focus = function (root) { $$('img[data-box]', root).forEach(focusOne); };
HRC.focus.one = focusOne;
HRC.focus.watch = function (root) {
var list = root && root.tagName === 'IMG' ? [root] : $$('img[data-box]', root);
list.forEach(function (im) { if (!focusRO) focusOne(im); else if (!im.__focus) { im.__focus = 1; focusRO.observe(im); } });
};
HRC.focus.watch();
function applyStill(pic, u) {
var ss = pic.tagName === 'PICTURE' ? pic.querySelectorAll('source') : [], img = pic.tagName === 'IMG' ? pic : pic.querySelector('img');
if (u.fp && pic.tagName === 'PICTURE') pic.setAttribute('style', u.fp);
for (var i = 0; i < ss.length && i < (u.srcs || []).length; i++) { ss[i].removeAttribute('data-srcset'); ss[i].setAttribute('srcset', u.srcs[i]); }
if (u.srcset != null) { img.removeAttribute('data-srcset'); img.setAttribute('srcset', u.srcset); }
img.removeAttribute('data-src'); img.removeAttribute('loading'); img.setAttribute('src', u.src);
if (u.box) img.setAttribute('data-box', u.box);
if (img.hasAttribute('data-box')) focusOne(img);
return img;
}
function decoded(img, u) {
var want = u ? [u.src || '', u.srcset || ''].concat(u.srcs || []).join(' ') : '';
var mine = function () { var c = img.currentSrc || img.getAttribute('src') || ''; return !want || (!!c && want.indexOf(c.split('?')[0].split('/').pop()) > -1); };
var loaded = new Promise(function (res) {
if (img.complete && img.naturalWidth && mine()) { res(); return; }
var t = setTimeout(done, 1500);
function done() { clearTimeout(t); img.removeEventListener('load', on); img.removeEventListener('error', done); res(); }
function on() { if (mine()) done(); }
img.addEventListener('load', on); img.addEventListener('error', done);
});
return loaded.then(function () { return img.decode ? img.decode().catch(function () {}) : null; });
}
HRC.still = {
swap: function (base, u, opts) {
opts = opts || {};
var bimg = base.tagName === 'IMG' ? base : base.querySelector('img');
if (!bimg) return Promise.resolve();
if (bimg.hasAttribute('data-src')) {            // not loaded yet (lazy): what it will load is the new still
var ss = base.tagName === 'PICTURE' ? base.querySelectorAll('source') : [];
for (var i = 0; i < ss.length && i < (u.srcs || []).length; i++) ss[i].setAttribute(ss[i].hasAttribute('srcset') ? 'srcset' : 'data-srcset', u.srcs[i]);
if (u.srcset != null) bimg.setAttribute('data-srcset', u.srcset);
bimg.setAttribute('data-src', u.src);
return Promise.resolve();
}
var st = base.__xf;
if (!st) {
var c = base.cloneNode(true);
[].slice.call(c.attributes).forEach(function (a) { if (/^(data-(?!box$|bg$)|id$)/.test(a.name)) c.removeAttribute(a.name); });
c.setAttribute('aria-hidden', 'true');
var ci = c.tagName === 'IMG' ? c : c.querySelector('img'); ci.alt = ''; ci.removeAttribute('fetchpriority');
c.classList.add('xf-layer', 'xf-back');
if (getComputedStyle(base.parentNode).position === 'static') base.parentNode.style.position = 'relative';
base.parentNode.insertBefore(c, base.nextSibling);
if (ci.hasAttribute('data-box')) HRC.focus.watch(ci);
st = base.__xf = { layers: [base, c], front: 0, token: 0, fading: -1 };
}
if (st.fading > -1) settle(st);                  // a fade in progress: finish it now
var tok = ++st.token, bi = 1 - st.front, back = st.layers[bi], front = st.layers[st.front];
var img = applyStill(back, u);
if (opts.alt != null) bimg.alt = opts.alt;
return decoded(img, u).then(function () {
if (tok !== st.token) return;
void back.offsetWidth;                        // the hidden state is on screen before the fade starts
back.classList.remove('xf-back');
if (bi === 1) back.classList.add('xf-in'); else { back.classList.add('xf-show'); front.classList.add('xf-out'); }
st.fading = bi;
if (HRC.RM || HRC.paused || HRC.motionMode === 'still' || opts.instant) { settle(st); return; }
return new Promise(function (res) { setTimeout(res, 170); }).then(function () { if (tok === st.token && st.fading === bi) settle(st); });
});
function settle(s) {
var f = s.fading; if (f < 0) return;
var old = s.layers[s.front], nw = s.layers[f];
old.classList.add('xf-back'); old.classList.remove('xf-out', 'xf-in', 'xf-show');
nw.classList.remove('xf-in', 'xf-show', 'xf-out');
s.front = f; s.fading = -1;
}
},
preload: function (base, list) {
if (!base || base.__xfPre) return;
base.__xfPre = list.map(function (u) {
var c = base.cloneNode(true), img = applyStill(c, u);
decoded(img, u);
return c;
});
},
};
HRC.hintUsed = function (name) {
if (ss.get('hrc.hint.' + name)) return;
ss.set('hrc.hint.' + name, '1');
$$('[data-hint="' + name + '"]').forEach(function (x) { x.classList.remove('show'); });
};
$$('[data-hint]').forEach(function (x) { if (!ss.get('hrc.hint.' + x.getAttribute('data-hint'))) x.classList.add('show'); });
function plate() {
var P = CFG.plate;
if (!P) return;
var wide = mm('(min-width: 900px) and (orientation: landscape)');
var el = d.createElement('div');
el.className = 'plate'; el.setAttribute('aria-hidden', 'true');
el.style.backgroundImage = 'url("' + (wide ? P.pd : P.pm) + '")';
var veil = d.createElement('div'); veil.className = 'plate__veil'; veil.setAttribute('aria-hidden', 'true');
d.body.insertBefore(veil, d.body.firstChild); d.body.insertBefore(el, d.body.firstChild);
var v = d.createElement('video');
v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none';
v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('disableremoteplayback', ''); v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1;
el.appendChild(v);
HRC.media.plate = v;
var heroGone = !$('[data-hero]');
var hasClip = !!$('[data-clip],[data-hero-video],[data-ride-video]');
function want() { return !HRC.paused && !d.hidden && heroGone && !HRC.media.anyPlaying() && (HRC.motionMode === 'video' || (HRC.motionMode == null && !hasClip)); }
function go() {
if (!want()) { if (!v.paused) v.pause(); return; }
if (!v.getAttribute('src')) v.setAttribute('src', wide ? P.d : P.m);
var p; try { p = v.play(); } catch (e) { p = Promise.reject(e); }
(p && p.then ? p : Promise.resolve()).then(function () {
if (HRC.motionMode == null) HRC.setMotionMode('video');
}, function (e) {
if (e && e.name === 'AbortError') return;       // paused before play() settled (a clip took over): not a refusal
v.removeAttribute('src'); try { v.load(); } catch (e2) {}
if (HRC.motionMode == null) { h.classList.add('no-autoplay'); HRC.setMotionMode('frames'); }
});
}
v.addEventListener('playing', function () { v.classList.add('on'); });
var hero = $('[data-hero]');
if (hero && 'IntersectionObserver' in W) {
new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting; go(); }, { threshold: 0.05 }).observe(hero);
}
HRC.on('motionmode', go); HRC.on('media-idle', go); HRC.on('motion', go);
d.addEventListener('visibilitychange', go);
go();
}
W.addEventListener('load', function () { setTimeout(function () { (W.requestIdleCallback || setTimeout)(plate, { timeout: 2000 }); }, 1500); }, { once: true });
if (location.hash.length > 1) {
var moved = false, mark = function () { moved = true; };
['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (e) { W.addEventListener(e, mark, { once: true, passive: true }); });
var reland = function () {
if (moved) return;
var t = null; try { t = d.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
if (t && t.scrollIntoView) t.scrollIntoView({ block: 'start' });
};
var settle = function () { requestAnimationFrame(function () { requestAnimationFrame(reland); }); setTimeout(reland, 400); };
if (d.readyState === 'complete') settle(); else W.addEventListener('load', settle, { once: true });
}
HRC.trap = function (box, onEsc) {
var prev = d.activeElement;
function focusables() { return $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetParent !== null || x === d.activeElement; }); }
function key(e) {
if (e.key === 'Escape') { e.preventDefault(); onEsc && onEsc(); return; }
if (e.key !== 'Tab') return;
var f = focusables(); if (!f.length) return;
var i = f.indexOf(d.activeElement);
if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
}
box.addEventListener('keydown', key);
setTimeout(function () { var f = focusables(); (f[0] || box).focus({ preventScroll: true }); }, 30);
return function release() { box.removeEventListener('keydown', key); if (prev && prev.focus) prev.focus({ preventScroll: true }); };
};
HRC.dialogOpen = 0;
(function () {
var sheet = $('[data-menu]'), btn = $('[data-menu-open]');
if (!sheet || !btn) return;
var release = null, t1 = 0, t2 = 0;
function open() {
clearTimeout(t1); clearTimeout(t2);
var r = btn.getBoundingClientRect();
sheet.style.setProperty('--bx', r.left + 'px'); sheet.style.setProperty('--by', r.top + 'px');
sheet.hidden = false;
d.body.classList.remove('menu-closing');
requestAnimationFrame(function () { d.body.classList.add('menu-open'); });
btn.setAttribute('aria-expanded', 'true');
d.body.style.overflow = 'hidden';
HRC.dialogOpen++; HRC.emit('sheet', true);
release = HRC.trap(sheet, close);
}
function close() {
if (!d.body.classList.contains('menu-open')) return;
btn.setAttribute('aria-expanded', 'false');
HRC.dialogOpen = Math.max(0, HRC.dialogOpen - 1); HRC.emit('sheet', false);
if (release) { release(); release = null; }
var fin = function () { d.body.classList.remove('menu-open', 'menu-closing'); d.body.style.overflow = ''; sheet.hidden = true; };
if (RM || HRC.paused) { fin(); return; }
d.body.classList.add('menu-closing');
t1 = setTimeout(function () { d.body.classList.remove('menu-open'); d.body.style.overflow = ''; t2 = setTimeout(fin, 1150); }, 320);
}
btn.addEventListener('click', open);
$$('[data-menu-close]', sheet).forEach(function (b) { b.addEventListener('click', close); });
$$('a', sheet).forEach(function (a) { a.addEventListener('click', close); });
HRC.closeMenu = close;
})();
var scrolled = false, topEl = $('.top'), hdrEl = topEl && $('.hdr', topEl), heroTop = !!(hdrEl && topEl.classList.contains('top--hero'));
var hdr = -1, hdrRaf = 0, hdrLast = 0, hdrOut = '';
function hdrTarget() { var x = Math.min(1, Math.max(0, (W.scrollY || 0) / 120)); return x * x * (3 - 2 * x); }
function hdrTick(ts) {
hdrRaf = 0;
var t = hdrTarget(), dt = hdrLast ? Math.min(0.1, (ts - hdrLast) / 1000) : 0;
hdrLast = ts;
hdr = hdr < 0 || RM || HRC.paused ? t : hdr + (t - hdr) * (1 - Math.exp(-dt / 0.117));
if (Math.abs(t - hdr) < 0.004) hdr = t;
var s = hdr.toFixed(3);
if (s !== hdrOut) { hdrOut = s; hdrEl.style.setProperty('--hdr', s); }
if (hdr !== t) hdrRaf = requestAnimationFrame(hdrTick); else hdrLast = 0;
}
function headerState() {
var s = (W.scrollY || 0) > 40; if (s !== scrolled) { scrolled = s; h.classList.toggle('scrolled', s); }
if (heroTop && !hdrRaf && hdrTarget() !== hdr) hdrRaf = requestAnimationFrame(hdrTick);
}
var io = ('IntersectionObserver' in W) ? new IntersectionObserver(function (es) {
var k = 0;
es.forEach(function (e) {
if (!e.isIntersecting) return;
var el = e.target;
if (!el.style.transitionDelay && k) { var ms = k * 70; el.style.transitionDelay = ms + 'ms'; setTimeout(function () { el.style.transitionDelay = ''; }, 1200 + ms); }
k++;
el.classList.add('in'); io.unobserve(el);
$$('[data-count]', el).forEach(countUp);
});
}, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }) : null;
var DESIGN = !!(W.Shopify && W.Shopify.designMode);
if (DESIGN) h.classList.add('design');
HRC.reveal = function (els) {
[].slice.call(els || []).forEach(function (el) {
if (!io || RM || HRC.paused || DESIGN) { el.classList.add('in'); return; }
io.observe(el);
});
};
['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (t) {
d.addEventListener(t, function (e) {
var root = e.target && e.target.querySelectorAll ? e.target : d;
$$('.rv, .ln', root).forEach(function (el) { el.classList.add('in'); });
$$('[data-count]', root).forEach(countUp);
if (root.matches && root.matches('.rv, .ln')) root.classList.add('in');
});
});
function countUp(el) {
if (el.getAttribute('data-done')) return;
el.setAttribute('data-done', '1');
var to = parseFloat(el.getAttribute('data-count')), pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '', t0 = 0;
var fin = pre + el.getAttribute('data-count') + suf;
if (!(to > 0) || RM || HRC.paused) { el.textContent = fin; return; }
requestAnimationFrame(function step(ts) {
if (!t0) t0 = ts;
var k = Math.min(1, (ts - t0) / 1200);
el.textContent = k < 1 ? pre + Math.round(to * (1 - Math.pow(1 - k, 3))) + suf : fin;
if (k < 1) requestAnimationFrame(step);
});
}
if (io && !RM && !HRC.paused) $$('.rv [data-count]').forEach(function (n) { n.textContent = (n.getAttribute('data-pre') || '') + '0' + (n.getAttribute('data-suf') || ''); });
$$('h1,h2,h3').forEach(function (hh) { $$('.ln', hh).forEach(function (l, i) { l.style.transitionDelay = (RM ? 0 : i * 80) + 'ms'; }); });
HRC.reveal($$('.rv, .ln'));
var CUR = HRC.t.cursor || {};
function filmOf(el) { return el && el.closest ? el.closest('video[data-clip], video[data-how-video]') : null; }
var pill = null, pillText = '', mx = -99, my = -99;
function cursorLabel(el) {
if (!el || !el.closest) return '';
var sw = el.closest('.sw__b[data-name], .vars__b[data-name]');
if (sw) return sw.getAttribute('data-name');
var v = filmOf(el);
if (v) return v.paused ? (CUR.play || '') : (CUR.pause || '');
if (el.closest('.pcard__media, .panel__media, [data-cursor="view"]')) return CUR.view || '';
if (el.closest('[data-ride] .ride__stage')) return CUR.scroll || '';
return '';
}
function cursorSet(t) {
if (!pill) return;
if (t && t !== pillText) pill.textContent = t;
pillText = t;
pill.classList.toggle('on', !!t);
}
(function () {
if (!FINE || CFG.cursor === 'system') return;
pill = d.createElement('div');
pill.className = 'cur'; pill.setAttribute('aria-hidden', 'true');
d.body.appendChild(pill);
var px = -99, py = -99, raf = 0;
function paint() {
var k = RM ? 1 : 0.2;
px += (mx - px) * k; py += (my - py) * k;
pill.style.transform = 'translate3d(' + (px + 14).toFixed(1) + 'px,' + (py + 18).toFixed(1) + 'px,0)';
raf = (Math.abs(mx - px) + Math.abs(my - py) > 0.3) ? requestAnimationFrame(paint) : 0;
}
W.addEventListener('pointermove', function (e) {
if (e.pointerType === 'touch') return;
if (!pillText) { px = e.clientX; py = e.clientY; }
mx = e.clientX; my = e.clientY;
cursorSet(cursorLabel(e.target));
if (!raf) raf = requestAnimationFrame(paint);
if (!MOTION || HRC.paused) return;
var b = e.target.closest && e.target.closest('.cta');
$$('.cta.mag').forEach(function (x) { if (x !== b) { x.style.transform = ''; x.classList.remove('mag'); } });
if (b) {
var r = b.getBoundingClientRect(), dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
b.classList.add('mag'); b.style.transform = 'translate(' + (dx * 0.12).toFixed(1) + 'px,' + (dy * 0.18).toFixed(1) + 'px)';
}
}, { passive: true });
d.documentElement.addEventListener('pointerleave', function () { cursorSet(''); });
W.addEventListener('scroll', function () { if (mx > -1) cursorSet(cursorLabel(d.elementFromPoint(mx, my))); }, { passive: true });
})();
var downX = 0, downY = 0;
d.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, true);
d.addEventListener('click', function (e) {
if (!FINE) return;
var v = filmOf(e.target);
if (!v || Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY) > 6 || HRC.motionMode === 'still') return;
if (v.__wokeAt && Date.now() - v.__wokeAt < 700) return;
if (v.paused) { v.__userPaused = false; HRC.media.play(v).then(function () { cursorSet(cursorLabel(v)); }, function () {}); }
else { v.__userPaused = true; v.pause(); HRC.media.idle(); }
cursorSet(cursorLabel(v));
});
var hooks = [];
HRC.onScroll = function (fn) { if (typeof fn === 'function') hooks.push(fn); };
(function () {
var q = false;
function tick() { q = false; headerState(); for (var i = 0; i < hooks.length; i++) hooks[i](); }
function ask() { if (!q) { q = true; requestAnimationFrame(tick); } }
W.addEventListener('scroll', ask, { passive: true });
W.addEventListener('resize', ask, { passive: true });
HRC.refresh = ask;
tick();
})();
function labelMotion() {
$$('[data-motion-toggle]').forEach(function (b) { b.textContent = HRC.paused ? (HRC.t.playMotion || 'Play motion') : (HRC.t.pauseMotion || 'Pause motion'); b.setAttribute('aria-pressed', HRC.paused ? 'true' : 'false'); });
}
labelMotion();
d.addEventListener('click', function (e) {
var b = e.target.closest('[data-motion-toggle]');
if (!b) return;
HRC.paused = !HRC.paused;
ls.set('hrc.motion', HRC.paused ? 'paused' : null);
h.classList.toggle('motion-paused', HRC.paused);
if (HRC.paused) { HRC.setMotionMode('still'); } else { var c = ss.get('hrc.motionMode'); HRC.setMotionMode(RM || HRC.saveData ? 'still' : (c === 'video' || c === 'frames' ? c : null)); }
if (HRC.paused && HRC.media.plate) { try { HRC.media.plate.pause(); } catch (x) {} }
labelMotion(); HRC.emit('motion', HRC.paused);
});
d.addEventListener('click', function (e) {
var b = e.target.closest('[data-privacy-toggle]');
if (!b) return;
var off = ls.get('hrc.optout') === '1';
ls.set('hrc.optout', off ? null : '1');
var st = $('[data-privacy-status]');
if (st) { st.hidden = false; st.textContent = off ? HRC.t.privacyOn : HRC.t.privacyOff; }
});
d.addEventListener('submit', function (e) {
var f = e.target.closest('[data-notify]');
if (!f) return;
var p = f.querySelector('[name=product]');
if (HRC.track) HRC.track('generate_lead', { form: f.getAttribute('name') || 'notify', product: p ? p.value : '' });
}, true);
var quizLoading = null;
function loadQuiz() {
if (W.HRC_QUIZ) return Promise.resolve(W.HRC_QUIZ);
if (quizLoading) return quizLoading;
quizLoading = new Promise(function (res, rej) {
if (CFG.quizCss && !$('link[data-quiz-css]')) { var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = CFG.quizCss; l.setAttribute('data-quiz-css', ''); d.head.appendChild(l); }
var s = d.createElement('script'); s.src = CFG.quizJs; s.async = true;
s.onload = function () { W.HRC_QUIZ ? res(W.HRC_QUIZ) : rej(new Error('quiz')); };
s.onerror = function () { quizLoading = null; rej(new Error('quiz')); };
d.head.appendChild(s);
});
return quizLoading;
}
HRC.openQuiz = function (source, pre) {
if (CFG.quiz && CFG.quiz.enabled === false) return false;
if (HRC.closeMenu) HRC.closeMenu();
loadQuiz().then(function (Q) { Q.open(source || 'cta', pre); }, function () { location.href = HRC.url('pages/find-your-scent'); });
return true;
};
d.addEventListener('click', function (e) {
var a = e.target.closest('[data-quiz-open]');
if (!a || CFG.page === 'quiz') return;
if (e.metaKey || e.ctrlKey || e.shiftKey) return;
e.preventDefault();
var who = a.getAttribute('data-quiz-who');
HRC.openQuiz(a.getAttribute('data-quiz-open'), who ? { who: who } : null);
});
if (/[?&]quiz=1(&|$)/.test(location.search) && CFG.page !== 'quiz') afterPaint(function () { HRC.openQuiz('url'); });
HRC.match = function () {
var m = ls.json('hrc.quiz.v1');
if (!m || !m.top || (Date.now() - (m.t || 0)) > 30 * 864e5) return null;
return m;
};
function applyMatch() {
var m = HRC.match();
if (!m) return;
var ids = [m.top].concat(m.alsoTry || []), T = HRC.t, gift = m.who === 'gift';
$$('[data-comps]').forEach(function (card) {
var cs = (card.getAttribute('data-comps') || '').split(' ');
var hit = ids.some(function (id) { return cs.indexOf(id) > -1; });
var chip = card.querySelector('[data-match-chip]');
if (chip) { chip.hidden = !hit; if (gift && T.matchChipGift) chip.textContent = T.matchChipGift; }
var ban = card.querySelector('[data-match-banner]');
if (ban && m.archName) { ban.hidden = !hit; ban.textContent = HRC.fmt(gift && T.matchBannerGift ? T.matchBannerGift : T.matchBanner, { archetype: m.archName }); }
});
var menu = $('[data-menu-match]');
if (menu && m.label) { menu.hidden = false; menu.textContent = HRC.fmt(gift && T.theirMatch ? T.theirMatch : T.yourMatch, { product: m.label }); }
var cta = $('[data-hero-cta2]');
if (cta && m.url && m.label) { cta.textContent = HRC.fmt(gift && T.theirMatch ? T.theirMatch : T.heroMatch, { product: m.label }); cta.setAttribute('href', HRC.url(m.url)); cta.removeAttribute('data-quiz-open'); }
}
HRC.applyMatch = applyMatch;
applyMatch();
var toastT = 0;
HRC.toast = function (msg) {
var t = $('[data-toast]'); if (!t) return;
t.textContent = msg; t.hidden = false; clearTimeout(toastT);
toastT = setTimeout(function () { t.hidden = true; }, 2400);
};
HRC.scentSwap = function (box, put, instant) {
if (!box) { put(); return; }
clearTimeout(box.__xf);
if (instant || HRC.RM || HRC.paused) { put(); box.classList.remove('scent-out'); return; }
box.classList.add('scent-out');
box.__xf = setTimeout(function () { put(); box.classList.remove('scent-out'); }, 100);
};
HRC.notesLine = function (el, notes) {
if (!el) return;
var ks = $$('[data-k]', el), parts = String(notes || '').split('|');
ks.forEach(function (k, i) { var n = k.nextSibling; if (n && n.nodeType === 3) n.nodeValue = ' ' + (parts[i] || '') + (i < ks.length - 1 ? ' · ' : ''); });
};
afterPaint(function () {
$$('[data-how-video]').forEach(function (v) {
var caps = $$('[data-how-caps] li', v.closest('.how') || d), cur = -1;
HRC.clip(v, { probe: true, observe: v.parentNode, threshold: 0.5,
src: function () { return mm('(min-width: 900px)') && v.getAttribute('data-d') ? v.getAttribute('data-d') : v.getAttribute('data-m'); } });
if (!caps.length) return;
function sync() {
var t = v.currentTime, k = -1;
caps.forEach(function (c, i) { if (t >= +c.getAttribute('data-t0') && t < +c.getAttribute('data-t1')) k = i; });
if (k === cur) return;
cur = k;
caps.forEach(function (c, i) { c.classList.toggle('on', i === k); });
}
function onFrame() { sync(); if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(onFrame); else if (!v.paused) requestAnimationFrame(onFrame); }
if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(onFrame);
v.addEventListener('playing', function () { if (!v.requestVideoFrameCallback) requestAnimationFrame(onFrame); });
v.addEventListener('timeupdate', sync);
v.addEventListener('seeked', sync);
});
});
afterPaint(function () { $$('video[data-clip]').forEach(function (v) { HRC.clip(v, { probe: true, observe: v.parentNode }); }); });
h.classList.add('ready');
})();
;
(function () {
'use strict';
var W = window, HRC = W.HRC, cfg = (HRC.cfg && HRC.cfg.tracking) || {};
var EVENTS = []; // test hook: every event, even with no vendor
var LOADED = [];
var ATTR = 'hrc.attr.v1', DAY = 864e5;
function optedOut() { return HRC.ls.get('hrc.optout') === '1' || navigator.globalPrivacyControl === true; }
HRC.optedOut = optedOut;
(function () {
var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'], got = {}, n = 0;
keys.forEach(function (k) { var v = q.get(k); if (v) { got[k] = String(v).slice(0, 200); n++; } });
var cur = HRC.ls.json(ATTR);
if (n && (!cur || Date.now() - (cur.t || 0) > 30 * DAY)) { got.t = Date.now(); HRC.ls.set(ATTR, JSON.stringify(got)); }
if (n) HRC.ss.set('hrc.adLanding', JSON.stringify(got));
})();
HRC.attribution = function () {
var a = HRC.ls.json(ATTR);
if (!a || Date.now() - (a.t || 0) > 30 * DAY) return {};
var o = {}; for (var k in a) if (k !== 't') o[k] = a[k];
return o;
};
HRC.fromAd = function () {
var a = HRC.ss.json('hrc.adLanding');
return !!(a && (a.gclid || a.fbclid || /^(cpc|paid|ppc)$/i.test(a.utm_medium || '')));
};
var fmt = cfg.contentIdFormat || { meta: '{variantId}', google: 'shopify_US_{productId}_{variantId}' };
function cid(kind, it) { return String(fmt[kind]).replace('{variantId}', it.variantId).replace('{productId}', it.productId); }
var meta = !!cfg.metaPixelId, ga = !!cfg.ga4MeasurementId, ads = !!cfg.googleAdsId;
var active = cfg.enabled !== false && (meta || ga || ads) && !optedOut();
if (active) {
if (meta && !W.fbq) {
var f = W.fbq = function () { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
if (!W._fbq) W._fbq = f; f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
W.fbq('init', cfg.metaPixelId); W.fbq('track', 'PageView');
}
if (ga || ads) {
W.dataLayer = W.dataLayer || [];
W.gtag = W.gtag || function () { W.dataLayer.push(arguments); };
W.gtag('js', new Date());
if (ga) W.gtag('config', cfg.ga4MeasurementId, { linker: { domains: cfg.linkerDomains || [] } });
if (ads) W.gtag('config', cfg.googleAdsId);
}
var loaded = false;
var load = function () {
if (loaded || optedOut()) return; loaded = true;
var add = function (src) { var s = document.createElement('script'); s.async = true; s.src = src; document.head.appendChild(s); LOADED.push(src); };
if (meta) add('https://connect.facebook.net/en_US/fbevents.js');
if (ga || ads) add('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.ga4MeasurementId || cfg.googleAdsId));
};
W.addEventListener('load', load, { once: true });
['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) { W.addEventListener(ev, load, { once: true, passive: true }); });
}
HRC.track = function (name, p) {
p = p || {};
EVENTS.push({ name: name, params: p, t: Date.now() });
if (cfg.debug && W.console) console.info('[hrc]', name, p);
if (!active || optedOut()) return;
var items = p.items || [];
var value = p.value != null ? p.value : items.reduce(function (s, i) { return s + (i.price || 0) * (i.qty || 1); }, 0);
var metaIds = items.map(function (i) { return cid('meta', i); });
var gItems = items.map(function (i) { return { item_id: cid('google', i), item_name: i.name, item_variant: i.variant, price: i.price, quantity: i.qty || 1 }; });
var fb = W.fbq, gt = W.gtag;
switch (name) {
case 'view_item':
if (fb) fb('track', 'ViewContent', { content_ids: metaIds, content_type: 'product', value: value, currency: 'USD' });
if (gt && ga) gt('event', 'view_item', { currency: 'USD', value: value, items: gItems });
break;
case 'add_to_cart':
if (fb) fb('track', 'AddToCart', { content_ids: metaIds, content_type: 'product', value: value, currency: 'USD' });
if (gt && ga) gt('event', 'add_to_cart', { currency: 'USD', value: value, items: gItems });
if (gt && ads && cfg.googleAdsLabels && cfg.googleAdsLabels.add_to_cart) gt('event', 'conversion', { send_to: cfg.googleAdsId + '/' + cfg.googleAdsLabels.add_to_cart, value: value, currency: 'USD' });
break;
case 'begin_checkout':
if (fb) fb('track', 'InitiateCheckout', { content_ids: metaIds, content_type: 'product', value: value, currency: 'USD', num_items: p.num_items });
if (gt && ga) gt('event', 'begin_checkout', { currency: 'USD', value: value, items: gItems });
if (gt && ads && cfg.googleAdsLabels && cfg.googleAdsLabels.begin_checkout) gt('event', 'conversion', { send_to: cfg.googleAdsId + '/' + cfg.googleAdsLabels.begin_checkout, value: value, currency: 'USD' });
break;
case 'generate_lead':
if (fb) fb('track', 'Lead', { content_name: p.form });
if (gt && ga) gt('event', 'generate_lead', { form: p.form, product: p.product });
break;
case 'quiz_open':
if (fb) fb('trackCustom', 'QuizStart', { source: p.source });
if (gt && ga) gt('event', 'quiz_open', { source: p.source });
break;
case 'quiz_complete':
if (fb) fb('trackCustom', 'QuizComplete', { content_ids: p.variantId ? [String(p.variantId)] : [], content_type: 'product' });
if (gt && ga) gt('event', 'quiz_complete', { top: p.top, env: p.env, picks: p.picks });
break;
default:
if (gt && ga && /^quiz_/.test(name)) gt('event', name, p);
}
};
HRC.track('page_view', { page: HRC.cfg.page, path: location.pathname });
})();
;
(function (root, factory) {
if (typeof module === 'object' && module.exports) module.exports = factory();
else root.HRC_PERMALINK = factory();
})(typeof self !== 'undefined' ? self : this, function () {
'use strict';
var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
function scentsValue(lines) {
var boxes = [];
lines.forEach(function (l) {
var s = l.attributes && l.attributes.Scents;
if (!s) return;
for (var i = 0; i < (l.qty || 1); i++) boxes.push(s);
});
if (!boxes.length) return null;
if (boxes.length === 1) return boxes[0];
return boxes.map(function (s, i) { return 'Box ' + (i + 1) + ': ' + s; }).join('; ');
}
function build(o) {
if (!o || !o.origin) throw new Error('origin required');
var known = o.known ? (o.known instanceof Set ? o.known : new Set((o.known || []).map(String))) : null;
var order = [], qty = {};
(o.lines || []).forEach(function (l) {
var id = String(l.variantId || '');
if (!/^\d+$/.test(id)) throw new Error('bad variant id: ' + id);
if (known && !known.has(id)) throw new Error('unknown variant id: ' + id);
var q = Math.max(1, Math.min(99, parseInt(l.qty, 10) || 1));
if (!(id in qty)) { order.push(id); qty[id] = 0; }
qty[id] += q;
});
if (!order.length) throw new Error('empty cart');
var url = o.origin.replace(/\/$/, '') + (o.cartPath || '/cart/') + order.map(function (id) { return id + ':' + qty[id]; }).join(',');
var params = [];
var add = function (k, v) { if (v != null && v !== '') params.push('attributes[' + k + ']=' + encodeURIComponent(String(v))); };
add('Scents', scentsValue(o.lines || []));
if (o.quizMatch) add('quiz_match', o.quizMatch);
var a = o.attribution || {};
ATTR_KEYS.forEach(function (k) { add(k, a[k]); });
params.push('ref=' + encodeURIComponent(a.utm_campaign || 'site'));
return url + '?' + params.join('&');
}
return { build: build, scentsValue: scentsValue, ATTR_KEYS: ATTR_KEYS };
});
;
(function (root, factory) {
if (typeof module === 'object' && module.exports) module.exports = factory();
else root.HRC_DOCK_RULES = factory();
})(typeof self !== 'undefined' ? self : this, function () {
'use strict';
var PAGES = { catalog: 1, lander: 1, pdp: 1 };
function evaluate(s, c) {
if (s.forced) return { show: true, reason: 'forced' };
if (!PAGES[s.page]) return { show: false, reason: 'page' };
if (s.pageSeconds < c.minPageSeconds) return { show: false, reason: 'too-early' };
if (s.doorUp) return { show: false, reason: 'door' };
if (s.sheetOpen || s.menuOpen) return { show: false, reason: 'sheet-open' };
if (s.typing) return { show: false, reason: 'form' };
if (s.quizCompleted) return { show: false, reason: 'quiz-done' };
if (s.dismissedAt && s.now - s.dismissedAt < c.suppressDays * 864e5) return { show: false, reason: 'dismissed' };
if (s.shownThisSession) return { show: false, reason: 'shown' };
if (s.checkoutClicked) return { show: false, reason: 'checkout' };
if (s.page === 'pdp' && s.pdpViews >= c.pdpViews) return { show: true, reason: 'pdp-second' };
if (s.bagCount > 0) return { show: false, reason: 'bag-not-empty' };
if (s.added) return { show: false, reason: 'buyer' };
if (s.scentChanges >= c.swatchChanges) return { show: true, reason: 'scents' };
if (s.pdpViewsNoAdd >= c.pdpViewsNoAdd) return { show: true, reason: 'pdp-views' };
if ((s.page === 'catalog' || s.page === 'pdp') && s.pageSeconds >= c.idleSeconds) return { show: true, reason: 'time' };
if (s.page === 'catalog' && s.panelsBack >= c.panelsBack) return { show: true, reason: 'scroll-back' };
return { show: false, reason: 'no-trigger' };
}
return { evaluate: evaluate };
});
;
(function () {
'use strict';
var W = window, d = document, HRC = W.HRC, $ = HRC.$, $$ = HRC.$$, t = HRC.t;
var KEY = 'hrc.bag.v1', LAST = 'hrc.bag.last', QUIZ = 'hrc.bag.quiz';
var memLines = null;
var dataP = null;
HRC.data = function () {
if (W.HRC_DATA && W.HRC_DATA.catalog) return Promise.resolve(W.HRC_DATA.catalog);
if (dataP) return dataP;
if (HRC.cfg.catalogJson) {
dataP = fetch(HRC.cfg.catalogJson, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('catalog'); return r.json(); })
.then(function (j) { var c = joinCatalog(j); W.HRC_DATA = W.HRC_DATA || {}; W.HRC_DATA.catalog = c; return c; }, function (e) { dataP = null; throw e; });
return dataP;
}
dataP = new Promise(function (res, rej) {
var s = d.createElement('script'); s.src = HRC.cfg.catalog; s.async = true;
s.onload = function () { W.HRC_DATA && W.HRC_DATA.catalog ? res(W.HRC_DATA.catalog) : rej(new Error('catalog')); };
s.onerror = function () { dataP = null; rej(new Error('catalog')); };
d.head.appendChild(s);
});
return dataP;
};
function joinCatalog(j) {
if (!j || !j.x) return j;
var c = j.x, shop = (j.shop && j.shop.products) || {}, known = {};
Object.keys(c.products).forEach(function (k) {
var p = c.products[k], s = shop[p.handle], any = false, used = [];
known[p.handle] = 1;
if (!s) { p.purchasable = false; p.url = { car: '/collections/car-fragrance', home: '/collections/home-fragrance', body: '/collections/shower-gel' }[p.env] || '/collections/all'; p.v.forEach(function (v) { v.id = null; }); return; }
p.v.forEach(function (v) { delete v.s; });
p.productId = s.id; p.price = s.price; p.url = s.url;
p.v.forEach(function (v) {
var sv = null;
s.v.forEach(function (x) { if (!sv && used.indexOf(x) < 0 && String(x.n).toLowerCase() === String(v.n).toLowerCase()) sv = x; });
if (!sv && s.v.length === 1 && p.v.length === 1) sv = s.v[0];
if (sv) { used.push(sv); v.id = sv.id; v.a = sv.a; if (sv.p != null) v.p = sv.p; if (sv.img && !/^(https?:)?\/\//.test(v.img || '')) { v.img = sv.img; v.img2 = sv.img2 || sv.img; } if (sv.a) any = true; } else { v.id = null; v.a = false; }
});
s.v.forEach(function (x) { if (used.indexOf(x) < 0) { p.v.push({ n: x.n, id: x.id, a: x.a, p: x.p, img: x.img, img2: x.img2 || x.img }); if (x.a) any = true; } });
p.purchasable = any;
});
Object.keys(shop).forEach(function (h) {
if (known[h]) return;
var s = shop[h];
c.products[h] = { id: h, handle: h, name: s.title, price: s.price, url: s.url, productId: s.id, def: 0, env: '',
single: s.v.length === 1 && /^default title$/i.test(String(s.v[0].n)),
purchasable: s.v.some(function (x) { return x.a; }),
v: s.v.map(function (x) { return { n: x.n, id: x.id, a: x.a, p: x.p, img: x.img, img2: x.img2 || x.img }; }) };
});
var pct = c.setDiscount && c.setDiscount.pct ? c.setDiscount.pct : 0;
Object.keys(c.products).forEach(function (k) {
c.products[k].v.forEach(function (v) {
if (!v.bn) return;
v.bn = v.bn.map(function (b) {
var total = 0, priced = true, buy = true;
b[1].forEach(function (m) {
var q = c.products[m[0]], qv = q && q.v[m[1]], pr = qv && qv.p != null ? qv.p : q ? q.price : null;
if (pr == null) priced = false; else total += pr;
if (!(q && q.purchasable && qv && qv.id && qv.a !== false)) buy = false;
});
total = Math.round(total * 100) / 100;
return [b[0], b[1], priced ? total : null, priced && pct ? Math.round(total * (100 - pct)) / 100 : null, buy ? 1 : 0];
});
});
});
return c;
}
HRC.afterPaint(function () { HRC.data().then(render, function () {}); });
function read() { return memLines || []; }
function write(lines) { memLines = lines; HRC.ls.set('hrc.cart.count', String(count(lines))); render(); HRC.emit('bag', lines); }
function cartLines(c, cat) {
return (c.items || []).map(function (it) {
var pid = null, v = null;
Object.keys(cat.products).forEach(function (k) { cat.products[k].v.forEach(function (x) { if (String(x.id) === String(it.variant_id)) { pid = k; v = x; } }); });
var p = pid && cat.products[pid];
return { key: it.key, variantId: String(it.variant_id), productId: pid || String(it.product_id), shopifyProductId: it.product_id, qty: it.quantity,
title: p ? p.name : it.product_title, variant: p && p.single ? '' : (v ? v.n : it.variant_title || ''), price: it.final_price / 100,
image: v ? (v.img || it.image) : it.image, url: it.url, attributes: it.properties && Object.keys(it.properties).length ? it.properties : null };
});
}
function cartGet() { return fetch(HRC.cfg.cartJs, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
function cartPost(url, body) {
return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'cart'); e.cart = j; throw e; } return j; }); });
}
function sync() { return Promise.all([cartGet(), HRC.data()]).then(function (x) { var lines = cartLines(x[0], x[1]); write(lines); return lines; }); }
HRC.afterPaint(function () { sync().catch(function () {}); });
function subtotal(lines) { return (lines || read()).reduce(function (s, l) { return s + l.price * l.qty; }, 0); }
function count(lines) { return (lines || read()).reduce(function (s, l) { return s + l.qty; }, 0); }
function lineFor(cat, pid, vi, opts) {
var p = cat.products[pid]; if (!p) throw new Error('unknown product ' + pid);
var v = p.v[vi == null ? p.def : vi];
if (!p.purchasable || !v || !v.id || v.a === false) throw new Error('not purchasable ' + pid);
return { variantId: String(v.id), productId: pid, shopifyProductId: p.productId, qty: (opts && opts.qty) || 1, title: p.name,
variant: p.single ? '' : v.n, price: v.p != null ? v.p : p.price, image: v.img, url: p.url + (v.s ? '?scent=' + v.s : ''), attributes: (opts && opts.attributes) || null };
}
function same(a, b) { return a.variantId === b.variantId && JSON.stringify(a.attributes || null) === JSON.stringify(b.attributes || null); }
var bag = HRC.bag = {
lines: read, subtotal: subtotal, count: count,
add: function (pid, vi, opts) {
return bag.addSet([[pid, vi]], opts).then(function (ls) { return ls[0]; });
},
addSet: function (list, opts) {
opts = opts || {};
return HRC.data().then(function (cat) {
var ls;
try { ls = list.map(function (x) { return lineFor(cat, x[0], x[1], opts); }); } catch (e) { HRC.toast(t.cartError || ''); throw e; }
var items = ls.map(function (l) { return { id: +l.variantId, quantity: l.qty, properties: l.attributes || {} }; });
var wasShown = !!(bbar && !bbar.hidden), l = ls[ls.length - 1];
return cartPost(HRC.cfg.cartAdd, { items: items }).then(sync).then(function () {
if (opts.quizMatch) HRC.ls.set(QUIZ, opts.quizMatch);
HRC.ss.set('hrc.s.added', '1');
HRC.lastAdded = list[list.length - 1][0];
enter(wasShown);
ls.forEach(function (x) { HRC.track('add_to_cart', { source: opts.source || '', items: [{ variantId: x.variantId, productId: x.shopifyProductId, name: x.title, variant: x.variant, price: x.price, qty: x.qty }] }); });
if (opts.open === true || (opts.open !== false && HRC.dialogOpen > 0)) bag.open(); else if (!opts.quiet) added(l, cat);
return ls;
}, function (e) { HRC.toast(t.cartError || (e && e.message) || ''); throw e; });
});
},
setQty: function (i, q) {
var l = read()[i]; if (!l) return;
return cartPost(HRC.cfg.cartChange, { line: i + 1, quantity: Math.max(0, Math.min(99, q)) }).then(sync, function (e) { HRC.toast(t.cartError || (e && e.message) || ''); sync(); });
},
open: open, close: close, checkout: checkout, render: render,
};
var drawer = $('[data-bag]'), release = null, opener = null;
function open() {
if (!drawer) return;
render();
opener = d.activeElement;
drawer.hidden = false;
requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('open'); }); });
$$('[data-bag-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
d.body.style.overflow = 'hidden';
HRC.dialogOpen++; HRC.emit('sheet', true); HRC.emit('drawer', true);
release = HRC.trap($('.drawer__panel', drawer), close);
}
function close() {
if (!drawer || drawer.hidden) return;
drawer.classList.remove('open');
$$('[data-bag-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
d.body.style.overflow = '';
HRC.dialogOpen = Math.max(0, HRC.dialogOpen - 1); HRC.emit('sheet', false); HRC.emit('drawer', false);
if (release) { release(); release = null; }
setTimeout(function () { if (!drawer.classList.contains('open')) drawer.hidden = true; }, HRC.RM ? 0 : 420);
}
d.addEventListener('click', function (e) {
if (e.target.closest('[data-bag-open]')) { e.preventDefault(); open(); return; }
if (e.target.closest('[data-bag-close]')) { close(); return; }
var q = e.target.closest('[data-qty]');
if (q) { bag.setQty(+q.getAttribute('data-i'), read()[+q.getAttribute('data-i')].qty + (+q.getAttribute('data-qty'))); return; }
var rm = e.target.closest('[data-rm]');
if (rm) { bag.setQty(+rm.getAttribute('data-rm'), 0); return; }
if (e.target.closest('[data-checkout]')) { checkout(); return; }
if (e.target.closest('[data-bag-restore]')) { restore(); return; }
var pa = e.target.closest('[data-bag-pair-add]');
if (pa) { bag.add(pa.getAttribute('data-bag-pair-add'), null, { source: 'bag-pair', open: true }); return; }
var add = e.target.closest('[data-add]');
if (add) { e.preventDefault(); bag.add(add.getAttribute('data-add'), +add.getAttribute('data-variant') || 0, { source: 'card' }); return; }
var qa = e.target.closest('[data-quick-add]');
if (qa) { e.preventDefault(); quick.open(qa.getAttribute('data-quick-add'), qa.hasAttribute('data-variant') ? +qa.getAttribute('data-variant') : null); }
});
function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
function shipText(kind, extra, lines, ids) {
var th = HRC.cfg.threshold, S = t.ship || {}, total = subtotal(lines);
if (th == null || !S.withThis) return '';
var have = ids.length > 0 && ids.every(function (id) { return lines.some(function (l) { return String(l.variantId) === id; }); });
if (have) return total >= th ? t.meterUnlocked : HRC.fmt(t.meterToGo, { n: Math.ceil(th - total) });
if (kind === 'set' && extra >= th) return S.setFree;
var left = Math.ceil(th - total - extra);
if (left <= 0) return kind === 'set' ? S.withSetFree : S.withThisFree;
return HRC.fmt(kind === 'set' ? S.setToGo : S.withThis, { n: left });
}
HRC.shipSync = function (root) {
var lines = read();
$$('[data-ship]', root || d).forEach(function (el) {
var x = shipText(el.getAttribute('data-ship'), +el.getAttribute('data-extra') || 0, lines, (el.getAttribute('data-ids') || '').split(',').filter(Boolean));
if (el.textContent !== x) el.textContent = x;
el.hidden = !x;
});
};
var setCardP = null;
HRC.setCardReady = function () {
if (HRC.setCard) return Promise.resolve();
if (setCardP) return setCardP;
setCardP = new Promise(function (res, rej) {
var s = d.createElement('script'); s.src = HRC.cfg.setcardJs; s.async = true;
s.onload = function () { HRC.setCard ? res() : rej(new Error('setcard')); };
s.onerror = function () { setCardP = null; rej(new Error('setcard')); };
d.head.appendChild(s);
});
return setCardP;
};
function meters(total) {
var th = HRC.cfg.threshold; if (th == null) return;
$$('[data-meter]').forEach(function (m) {
var left = Math.max(0, th - total), done = left <= 0, pdp = !!m.closest('[data-pdp-meter]');
var txt = done ? (pdp ? t.pdpMeterOk : t.meterUnlocked) : HRC.fmt(pdp ? t.pdpMeter : t.meterToGo, { n: left });
var tx = m.querySelector('[data-meter-text]'); if (tx && tx.textContent !== txt) tx.textContent = txt;
var f = m.querySelector('[data-meter-fill]'); if (f) f.style.setProperty('--m', Math.min(1, total / th).toFixed(3));
m.classList.toggle('is-done', done);
});
}
var bbar = $('[data-bagbar]'), typing = false;
function barSync(n, total) {
if (!bbar) return;
if (n == null) { var ls0 = read(); n = count(ls0); total = subtotal(ls0); }
var show = n > 0 && !(HRC.dialogOpen - (csPop ? 1 : 0)) && !typing;
if (bbar.hidden === show) bbar.hidden = !show;
var h = show ? bbar.offsetHeight + (parseFloat(getComputedStyle(bbar).bottom) || 0) : 0;
d.documentElement.style.setProperty('--bagbar-h', h + 'px');
d.documentElement.classList.toggle('bag', n > 0);
d.body.classList.toggle('has-bagbar', show);
var th = HRC.cfg.threshold, left = th == null ? 0 : Math.max(0, th - total);
var sum = $('[data-bagbar-total]', bbar); if (sum) sum.textContent = HRC.money(total);
var m = $('[data-bagbar-meter]', bbar); if (m && th != null) m.textContent = left > 0 ? HRC.fmt(t.meterToGo, { n: left }) : t.meterUnlocked;
HRC.emit('bagbar', show);
}
function enter(wasShown) {
if (!bbar || bbar.hidden || HRC.RM || HRC.paused) return;
if (!wasShown) { bbar.classList.remove('rise'); void bbar.offsetWidth; bbar.classList.add('rise'); }
var c = $('.bagbar__c', bbar);
if (c) { c.classList.remove('pulse'); void c.offsetWidth; c.classList.add('pulse'); }
}
if (bbar) bbar.addEventListener('animationend', function (e) {
if (e.animationName === 'bagbar-rise') bbar.classList.remove('rise');
if (e.animationName === 'badge-pulse') e.target.classList.remove('pulse');
});
HRC.on('sheet', function () { setTimeout(barSync, 0); });
d.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input, textarea, select') && !(csPop && cs.contains(e.target))) { typing = true; barSync(); } });
d.addEventListener('focusout', function () { if (typing) { typing = false; setTimeout(barSync, 0); } });
W.addEventListener('resize', function () { barSync(); }, { passive: true });
barSync();
var addT = 0;
function added(l, cat) {
var a = bbar && $('[data-bagbar-added]', bbar);
if (!a || bbar.hidden) { HRC.toast(t.added); return; }
var msg = HRC.fmt(t.bagbarAdded, { item: l.title + (l.variant ? ', ' + l.variant : '') });
a.textContent = msg; a.hidden = false; bbar.classList.add('is-added');
var say = $('[data-bagbar-say]', bbar); if (say) say.textContent = msg;
clearTimeout(addT);
addT = setTimeout(function () { bbar.classList.remove('is-added'); a.hidden = true; }, 2400);
HRC.emit('bag-added', l);
more(l, cat);
}
var setLink = bbar && $('[data-bagbar-set]', bbar);
function more(l, cat) {
if (!setLink) return;
var p = cat.products[l.productId], v = null;
if (p) p.v.forEach(function (x) { if (String(x.id) === String(l.variantId)) v = x; });
var key = v && v.comp ? 'hrc.s.more.' + v.comp : '';
if (!cat.sets || !p || p.env !== 'car' || !v || !v.comp || !cat.sets[v.comp] || HRC.ss.get(key)) { bbar.classList.remove('has-set'); setLink.hidden = true; return; }
HRC.ss.set(key, '1');
setLink.setAttribute('href', HRC.vurl(p, v) + '#set');
setLink.setAttribute('data-comp', v.comp); setLink.setAttribute('data-product', p.id);
setLink.hidden = false;
bbar.classList.add('has-set');
}
var cs = $('[data-cscent]'), csRel = null, csPop = false, csOn = false;
function csOpen(comp, pid) {
var cat = W.HRC_DATA && W.HRC_DATA.catalog, S3 = cat && cat.sets && cat.sets[comp], p = cat && cat.products[pid], Z = t.set || {};
if (!cs || !S3 || !p || csOn) return false;
var v = null; p.v.forEach(function (x) { if (x.comp === comp && !v) v = x; });
var scent = p.single || !v ? p.name : v.n, names = [p.single || !v ? p.name : p.name + ' ' + v.n];
var im = function (x) { var src = x && (x.img || x.img2); return src ? '<img src="' + esc(HRC.url(src)) + '" width="360" height="360" alt="" loading="lazy" decoding="async">' : ''; };
var sells = function (q, qv) { return !!(q.purchasable && qv && qv.id); };
var pieces = [{ kind: 'car', name: p.single || !v ? p.name : v.n, sub: p.single || !v ? Z.car : p.name, href: HRC.vurl(p, v), img: im(v), sells: sells(p, v) }];
['home', 'shower'].forEach(function (w) {
var q = S3[w] && cat.products[S3[w].id], qv = q && q.v[S3[w].vi || 0]; if (!qv) return;
var qn = q.single ? q.name : qv.n;
names.push(qn);
pieces.push({ kind: w, name: qn, sub: q.single ? Z[w] : q.name, href: HRC.vurl(q, qv), img: im(qv), line: HRC.fmt(S3[w].w, { scent: scent }), sells: sells(q, qv), match: S3[w].m });
});
if (pieces.length < 2) return false;
var id = 'cs' + Math.random().toString(36).slice(2, 7);
var nm = function (it) { var q = cat.products[it[0]], qv = q && q.v[it[1]]; return !q ? '' : q.single || !qv ? q.name : q.env === 'car' ? q.name + ' ' + qv.n : qv.n; };
var bns = (v && v.bn) || [], allBuy = bns.length > 0;
var bundles = bns.map(function (b) {
var names2 = b[1].map(nm).join(' · '), buy = b[4] === 1;
if (!buy) allBuy = false;
return { key: b[0], names: names2, buy: buy, sum: b[3] != null ? b[3] : b[2],
total: b[2] == null ? '' : b[3] != null ? HRC.fmt(Z.totalLess, { price: HRC.money(b[3]), was: HRC.money(b[2]) }) : HRC.fmt(Z.total, { price: HRC.money(b[2]) }),
ids: b[1].map(function (it) { var q = cat.products[it[0]], qv = q && q.v[it[1]]; return qv && qv.id ? String(qv.id) : ''; }).filter(Boolean),
act: buy ? '<button type="button" class="cta bnd__add" data-cs-add="' + esc(b[1].map(function (it) { return it[0] + ':' + it[1]; }).join(',')) + '">' + esc(Z.addSet) + '</button>'
: '<button type="button" class="cta cta--ghost bnd__notify" data-cs-notify="' + esc(names2) + '">' + esc(Z.notify) + '</button>' };
});
var fullNames = bns.length ? bns[bns.length - 1][1].map(nm).join(' · ') : names.join(' · ');
$('[data-cscent-body]', cs).innerHTML = HRC.setCard({ pieces: pieces, bundles: bundles, id: id + 'c' }) +
'<form class="notify" name="notify-set" method="POST" data-netlify="true" netlify-honeypot="bot-field" action="/pages/thanks.html" data-notify' + (allBuy ? ' hidden' : '') + '>' +
'<input type="hidden" name="form-name" value="notify-set"><input type="hidden" name="product" value="' + esc(p.handle || p.id) + '">' +
'<input type="hidden" name="scent" value="' + esc(scent) + '"><input type="hidden" name="set" value="' + esc(fullNames) + '" data-cs-set>' +
'<p class="notify__h">' + esc(Z.notify) + '</p><p class="micro cscent__nl">' + esc(Z.notifyLine) + '</p><p hidden><label>Leave empty <input name="bot-field"></label></p>' +
'<div class="notify__row"><label class="vh" for="' + id + '">' + esc(t.email) + '</label><input id="' + id + '" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="' + esc(t.email) + '">' +
'<button class="cta" type="submit">' + esc(t.notifyBtn) + '</button></div></form>';
HRC.shipSync(cs);
csPop = W.matchMedia('(min-width:900px)').matches;
cs.classList.toggle('cscent--pop', csPop);
cs.style.setProperty('--cs-b', (parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--bagbar-h')) || 0) + 'px');
csOn = true; cs.hidden = false;
requestAnimationFrame(function () { requestAnimationFrame(function () { if (csOn) cs.classList.add('open'); }); });
HRC.dialogOpen++; HRC.emit('sheet', true);
csRel = HRC.trap($('.cscent__panel', cs), csClose);
HRC.track('complete_scent_open', { comp: comp, product: p.id });
return true;
}
function csClose() {
if (!csOn) return;
csOn = false; csPop = false;
cs.classList.remove('open');
if (setLink) { setLink.hidden = true; bbar.classList.remove('has-set'); }
HRC.dialogOpen = Math.max(0, HRC.dialogOpen - 1); HRC.emit('sheet', false);
if (csRel) { csRel(); csRel = null; }
setTimeout(function () { if (!csOn) cs.hidden = true; }, HRC.RM ? 0 : 420);
}
if (cs) $$('[data-cscent-close]', cs).forEach(function (b) { b.addEventListener('click', csClose); });
if (cs) cs.addEventListener('click', function (e) {
var a = e.target.closest('[data-cs-add]'), n = e.target.closest('[data-cs-notify]');
if (a) {
var its = a.getAttribute('data-cs-add').split(',').map(function (s) { var q = s.split(':'); return { p: q[0], v: +q[1] || 0 }; });
bag.addSet(its.map(function (it) { return [it.p, it.v]; }), { source: 'complete-scent', open: false })
.then(function () { csClose(); });
} else if (n) {
var f = $('form[name="notify-set"]', cs), x = f && $('[data-cs-set]', f);
if (x) x.value = n.getAttribute('data-cs-notify');
if (f) { f.hidden = false; var em = $('input[type="email"]', f); if (em) em.focus(); }
}
});
if (setLink) setLink.addEventListener('click', function (e) {
if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
var comp = setLink.getAttribute('data-comp'), pid = setLink.getAttribute('data-product'), cat = W.HRC_DATA && W.HRC_DATA.catalog, href = setLink.href;
if (!cs || csOn || !cat || !cat.sets || !cat.sets[comp] || !cat.products[pid]) return;
e.preventDefault();
HRC.setCardReady().then(function () { if (!csOpen(comp, pid)) location.href = href; }, function () { location.href = href; });
});
function render() {
var lines = read(), total = subtotal(lines), n = count(lines);
$$('[data-bag-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; c.setAttribute('aria-label', HRC.fmt(t.bagCount, { n: n })); });
meters(total);
HRC.shipSync();
barSync(n, total);
if (!drawer) return;
var box = $('[data-bag-lines]', drawer);
box.innerHTML = lines.map(function (l, i) {
return '<div class="line"><a class="line__img" href="' + esc(HRC.url(l.url || '')) + '" tabindex="-1" aria-hidden="true">' + (l.image ? '<img src="' + esc(HRC.url(l.image)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
'<div><p class="line__n">' + esc(l.title) + '</p>' + (l.variant ? '<p class="line__v">' + esc(l.variant) + '</p>' : '') +
(l.attributes && l.attributes.Scents ? '<p class="line__v">' + esc(HRC.fmt(t.giftScents, { scents: l.attributes.Scents })) + '</p>' : '') +
'<div class="qty" role="group" aria-label="' + esc(t.qty) + '"><button type="button" data-qty="-1" data-i="' + i + '" aria-label="' + esc(t.decrease) + '">−</button><span>' + l.qty + '</span><button type="button" data-qty="1" data-i="' + i + '" aria-label="' + esc(t.increase) + '">+</button></div>' +
'<button type="button" class="line__rm" data-rm="' + i + '">' + esc(t.remove) + '</button></div>' +
'<p class="line__p">' + HRC.money(l.price * l.qty) + '</p></div>';
}).join('');
$('[data-bag-empty]', drawer).hidden = lines.length > 0;
$('[data-bag-foot]', drawer).hidden = lines.length === 0;
$('[data-bag-subtotal]', drawer).textContent = HRC.money(total);
var co = $('[data-checkout]', drawer); if (co) co.textContent = HRC.fmt(t.checkout, { total: total });
var last = HRC.ls.json(LAST);
$('[data-bag-restore]', drawer).hidden = !(lines.length === 0 && last && last.lines && Date.now() - last.t < 864e5);
renderPair(lines, total);
}
function renderPair(lines, total) {
var box = $('[data-bag-pair]', drawer), cat = W.HRC_DATA && W.HRC_DATA.catalog;
var th = HRC.cfg.threshold;
if (!box || !cat || !lines.length || th == null || total >= th) { if (box) box.hidden = true; return; }
var inBag = {}; lines.forEach(function (l) { inBag[l.productId] = 1; });
var src = cat.products[HRC.lastAdded || lines[lines.length - 1].productId];
var ids = (src && src.pairs || []).concat(['mirror-standard', 'vent-standard', 'vent-premium', 'perfume-premium']);
var pick = null;
for (var i = 0; i < ids.length && !pick; i++) { var p = cat.products[ids[i]]; if (p && p.purchasable && !inBag[p.id] && total + p.price >= th) pick = p; }
if (!pick) { box.hidden = true; return; }
var v = pick.v[pick.def];
box.hidden = false;
box.innerHTML = '<p class="label">' + esc(t.pairsWell) + '</p><div class="pairs"><div class="line"><span class="line__img">' + (v.img ? '<img src="' + esc(HRC.url(v.img)) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</span>' +
'<div><p class="line__n">' + esc(pick.name) + '</p><p class="line__v">' + esc(pick.single ? '' : v.n) + ' · ' + HRC.money(pick.price) + '</p>' +
'<p class="micro pairs__ship" data-ship="item" data-extra="' + pick.price + '" data-ids="' + esc(v.id || '') + '"></p></div>' +
'<button type="button" class="mini-add" data-bag-pair-add="' + pick.id + '">' + esc(t.add) + '</button></div></div>';
HRC.shipSync(box);
}
HRC.on('bag', function () { HRC.applyMatch && HRC.applyMatch(); });
function checkout() {
var lines = read(); if (!lines.length) return;
var total = subtotal(lines), go = function () { location.href = HRC.cfg.checkout; };
HRC.ss.set('hrc.s.checkout', '1');
HRC.track('begin_checkout', { value: total, num_items: count(lines), url: HRC.cfg.checkout,
items: lines.map(function (l) { return { variantId: l.variantId, productId: l.shopifyProductId, name: l.title, variant: l.variant, price: l.price, qty: l.qty }; }) });
var attrs = HRC.attribution ? HRC.attribution() : {}, qm = HRC.ls.get(QUIZ);
if (qm) attrs['Quiz match'] = qm;
HRC.ls.set(QUIZ, null);
if (Object.keys(attrs).length) cartPost(HRC.cfg.cartUpdate, { attributes: attrs }).then(go, go); else go();
}
function restore() {
var last = HRC.ls.json(LAST); if (!last || !last.lines) return;
HRC.ls.set(LAST, null);
write(last.lines);
}
var qs = $('[data-quick]'), qrel = null;
var quick = HRC.quick = {
open: function (pid, vi, opts) {
opts = opts || {};
if (!qs) return;
HRC.data().then(function (cat) {
var p = cat.products[pid]; if (!p) return;
var cur = vi == null ? p.def : vi, body = $('[data-quick-body]', qs);
var title = $('[data-quick-title]', qs);
if (title) title.textContent = p.pick ? t.giftPick : t.chooseScent;
var img = function (v) { return v.img2 || v.img; };
if (p.pick) {
body.innerHTML = '<div class="qa__body" data-gift data-product="' + p.id + '" data-need="' + p.pick + '" data-price="' + p.price + '"><div class="qa__row"><div class="qa__img"><img src="' + esc(HRC.url(img(p.v[0]))) + '" alt="" width="360" height="360"></div><div><p class="qa__n">' + esc(p.name) + '</p><p class="pcard__p">' + HRC.money(p.price) + '</p></div></div>' +
'<fieldset class="sw pick"><legend class="label">' + esc(t.giftPick) + '</legend><div class="sw__row" data-gift-pool>' + p.pool.map(function (s) { return '<button type="button" class="sw__b" aria-pressed="false" data-g="' + esc(s.n) + '" data-name="' + esc(s.n) + '" style="--c:' + esc(s.c) + '"><i aria-hidden="true"></i><span>' + esc(s.n) + '</span></button>'; }).join('') +
'</div><p class="pick__out" data-gift-out role="status">' + esc(t.giftEmpty) + '</p></fieldset><button type="button" class="cta cta--block" data-gift-add disabled>' + esc(t.giftCtaPick) + '</button></div>';
HRC.gift($('[data-gift]', body), { source: 'quick-add', onAdded: quick.close });
} else {
var sw = p.single ? '' : '<fieldset class="sw"><legend class="label">' + esc(t.chooseScent) + '</legend><div class="sw__row" role="radiogroup">' + p.v.map(function (v, i) {
return '<button type="button" class="sw__b" role="radio" aria-checked="' + (i === cur) + '" data-qv="' + i + '" data-name="' + esc(v.n) + '" style="--c:' + esc(v.c) + '"><i aria-hidden="true"></i><span>' + esc(v.n) + '</span></button>';
}).join('') + '</div></fieldset>';
var comp = function (i) { return p.v[i].comp && cat.comps[p.v[i].comp]; };
var line = function (i) { var c = comp(i); return c ? c.line : ''; };
var notes = function (i) { var c = comp(i); return c ? [c.top, c.heart, c.base].map(function (s) { return String(s || '').split(',')[0].trim(); }).join('|') : ''; };
var notesHtml = function (i) {
var n = notes(i).split('|'), L = t.notes || {};
return notes(i) ? '<p class="notes1" data-qnotes>' + ['top', 'heart', 'base'].map(function (k, j) { return '<span data-k>' + esc(L[k] || k) + '</span> ' + esc(n[j] || '') + (j < 2 ? ' · ' : ''); }).join('') + '</p>' : '';
};
body.innerHTML = '<div class="qa__body"><div class="qa__row"><div class="qa__img"><img data-qimg src="' + esc(HRC.url(img(p.v[cur]))) + '" alt="" width="360" height="360"></div><div><p class="qa__n" data-qn>' + esc(p.name) + (p.single ? '' : ' — ' + esc(p.v[cur].n)) + '</p><p class="pcard__p">' + HRC.money(p.price) + '</p></div></div>' +
'<div class="qa__scent" data-qscent data-scent-box aria-live="polite"><p class="qa__line" data-qline>' + esc(line(cur)) + '</p>' + notesHtml(cur) + '</div>' + sw + '<button type="button" class="cta cta--block" data-qadd>' + esc(HRC.fmt(t.addToBag, { price: p.price })) + '</button></div>';
$$('[data-qv]', body).forEach(function (b) {
b.addEventListener('click', function () {
cur = +b.getAttribute('data-qv');
$$('[data-qv]', body).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
$('[data-qimg]', body).src = HRC.url(img(p.v[cur]));
HRC.scentSwap($('[data-qscent]', body), function () {
$('[data-qn]', body).textContent = p.name + ' — ' + p.v[cur].n;
$('[data-qline]', body).textContent = line(cur);
HRC.notesLine($('[data-qnotes]', body), notes(cur));
});
if (opts.onPick) { opts.onPick(cur); quick.close(); }
HRC.emit('variant-tried', { product: pid, variant: cur });
});
});
$('[data-qadd]', body).addEventListener('click', function () {
quick.close();
if (opts.onPick) { opts.onPick(cur); }
bag.add(pid, cur, { source: opts.source || 'quick-add' });
});
}
qs.hidden = false;
requestAnimationFrame(function () { requestAnimationFrame(function () { qs.classList.add('open'); }); });
d.body.style.overflow = 'hidden';
HRC.dialogOpen++; HRC.emit('sheet', true);
qrel = HRC.trap($('.qa__panel', qs), quick.close);
});
},
close: function () {
if (!qs || qs.hidden) return;
qs.classList.remove('open'); d.body.style.overflow = '';
HRC.dialogOpen = Math.max(0, HRC.dialogOpen - 1); HRC.emit('sheet', false);
if (qrel) { qrel(); qrel = null; }
setTimeout(function () { if (!qs.classList.contains('open')) qs.hidden = true; }, HRC.RM ? 0 : 400);
},
};
if (qs) $$('[data-quick-close]', qs).forEach(function (b) { b.addEventListener('click', quick.close); });
HRC.gift = function (root, opts) {
if (!root || root.__gift) return; root.__gift = true;
opts = opts || {};
var need = +root.getAttribute('data-need') || 4, picked = [];
var scope = root.closest('[data-panel],[data-pdp],.gift-s,[data-quick-body]') || root;
var out = root.querySelector('[data-gift-out]') || scope.querySelector('[data-gift-out]');
var btn = root.querySelector('[data-gift-add]') || scope.querySelector('[data-gift-add]');
var link = root.querySelector('[data-gift-link]');
var host = root.classList.contains('gift') ? root : (root.querySelector('.pick') || root);
$$('[data-g]', root).forEach(function (b) {
b.addEventListener('click', function () {
var n = b.getAttribute('data-g'), at = picked.indexOf(n);
if (at > -1) { picked.splice(at, 1); b.setAttribute('aria-pressed', 'false'); }
else { if (picked.length >= need) return; picked.push(n); b.setAttribute('aria-pressed', 'true'); }
var left = need - picked.length;
host.classList.toggle('is-full', left === 0); root.classList.toggle('is-full', left === 0);
$$('[data-g]', root).forEach(function (o) { if (left === 0 && o.getAttribute('aria-pressed') !== 'true') o.setAttribute('aria-disabled', 'true'); else o.removeAttribute('aria-disabled'); });
if (out) out.textContent = !picked.length ? t.giftEmpty : picked.join(' · ') + (left ? ' — ' + HRC.fmt(t.giftToGo, { n: left }) : '');
if (btn) { btn.disabled = left !== 0; btn.textContent = left ? t.giftCtaPick : btn.getAttribute('data-cta-set') || HRC.fmt(t.giftCta, { price: +root.getAttribute('data-price') }); }
if (link && btn) { link.hidden = left === 0; btn.hidden = left !== 0; }
});
});
if (btn) btn.addEventListener('click', function () {
if (picked.length !== need) return;
bag.add(root.getAttribute('data-product') || 'gift-box', 0, { attributes: { Scents: picked.join(', ') }, source: opts.source || 'gift' })
.then(function () { if (opts.onAdded) opts.onAdded(); });
});
};
$$('[data-gift]').forEach(function (g) { HRC.gift(g); });
if (HRC.FINE && W.matchMedia && W.matchMedia('(hover:hover)').matches) $$('.pcard__alt').forEach(function (a) {
var card = a.closest('.pcard__media');
card.addEventListener('mouseenter', function () {
$$('[data-srcset]', a).forEach(function (x) { x.setAttribute('srcset', x.getAttribute('data-srcset')); });
$$('[data-src]', a).forEach(function (x) { x.setAttribute('src', x.getAttribute('data-src')); });
var img = a.querySelector('img');
var on = function () { a.classList.add('ready'); };
if (img && !img.complete) img.addEventListener('load', on, { once: true }); else on();
}, { once: true });
});
render();
})();
;
(function () {
'use strict';
var W = window, d = document, HRC = W.HRC, cfg = HRC.cfg;
var dock = HRC.$('[data-dock]');
if (!cfg.dock || !dock || !W.HRC_DOCK_RULES || !(cfg.quiz && cfg.quiz.enabled !== false)) return;
var C = cfg.quiz.dock || {};
var now = function () { return Date.now(); };
var p0 = now();
var seenPdps = HRC.ss.json('hrc.s.pdps') || [];
if (cfg.page === 'pdp' && seenPdps.indexOf(location.pathname) < 0) { seenPdps.push(location.pathname); HRC.ss.set('hrc.s.pdps', JSON.stringify(seenPdps)); }
function changes() { return HRC.ss.json('hrc.s.changes') || {}; }
HRC.on('variant-tried', function (x) {
if (!x || !x.product) return;
var m = changes(); m[x.product] = (m[x.product] || 0) + 1;
HRC.ss.set('hrc.s.changes', JSON.stringify(m));
check();
});
var panels = cfg.page === 'catalog' ? HRC.$$('[data-panel]') : [], deepest = 0, back = 0;
function panelAt() {
var mid = W.innerHeight / 2, k = 0;
for (var i = 0; i < panels.length; i++) if (panels[i].getBoundingClientRect().top <= mid) k = i;
return k;
}
if (panels.length) HRC.onScroll(function () {
if (shown && !closed) return;                    // (the page under the invitation does not move)
var k = panelAt();
if (k > deepest) deepest = k;
if (deepest - k > back) { back = deepest - k; check(); }
});
var quizOpen = false, doorUp = true;
HRC.on('quiz', function (open) { quizOpen = !!open; });
if (HRC.doorOpen) HRC.doorOpen(function () { doorUp = false; }); else doorUp = false;
function typing() { var a = d.activeElement; return !!(a && a.matches && a.matches('input, textarea, select')); }
function state() {
var added = HRC.ss.get('hrc.s.added') === '1', m = changes(), most = 0;
Object.keys(m).forEach(function (k) { if (m[k] > most) most = m[k]; });
return {
page: cfg.page, pageSeconds: (now() - p0) / 1000, bagCount: HRC.bag ? HRC.bag.count() : 0, added: added,
checkoutClicked: HRC.ss.get('hrc.s.checkout') === '1', sheetOpen: HRC.dialogOpen > 0 || quizOpen,
menuOpen: d.body.classList.contains('menu-open'), typing: typing(), doorUp: doorUp,
quizCompleted: !!(HRC.match && HRC.match()) || HRC.ss.get('hrc.s.quizDone') === '1',
dismissedAt: +HRC.ls.get('hrc.dock.dismissed') || null, now: now(), shownThisSession: HRC.ss.get('hrc.s.dockShown') === '1',
scentChanges: added ? 0 : most, pdpViewsNoAdd: added ? 0 : seenPdps.length, pdpViews: seenPdps.length, panelsBack: back,
forced: false,
};
}
var shown = false, closed = false, release = null, inerted = [], lockY = 0, prevOverflow = '', prevHtml = '';
function lock() {
lockY = W.pageYOffset;
prevOverflow = d.body.style.overflow; prevHtml = d.documentElement.style.overflow;
d.body.style.overflow = 'hidden'; d.documentElement.style.overflow = 'hidden';
inerted = [];
Array.prototype.forEach.call(d.body.children, function (el) {
if (el === dock || el.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
el.setAttribute('inert', ''); inerted.push(el);
});
}
function unlock() {
inerted.forEach(function (el) { el.removeAttribute('inert'); }); inerted = [];
d.body.style.overflow = prevOverflow; d.documentElement.style.overflow = prevHtml;
if (Math.round(W.pageYOffset) !== Math.round(lockY)) {
var r = d.documentElement, sb = r.style.scrollBehavior;
r.style.scrollBehavior = 'auto'; W.scrollTo(0, lockY); r.style.scrollBehavior = sb;
}
}
function show(reason) {
if (shown) return; shown = true;
HRC.ss.set('hrc.s.dockShown', '1');
lock();
dock.hidden = false;
HRC.dialogOpen++; HRC.emit('sheet', true);
requestAnimationFrame(function () { requestAnimationFrame(function () { dock.classList.add('show'); }); });
release = HRC.trap(dock, function () { close('esc'); });
HRC.track('quiz_invite_shown', { reason: reason, page: cfg.page });
}
function close(how) {
if (!shown || closed) return; closed = true;
if (how === 'close' || how === 'esc') HRC.ls.set('hrc.dock.dismissed', String(now()));
if (how !== 'start') HRC.track('quiz_invite_dismiss', { how: how, page: cfg.page });
dock.classList.remove('show');
HRC.dialogOpen = Math.max(0, HRC.dialogOpen - 1); HRC.emit('sheet', false);
unlock();
if (release) { release(); release = null; }
setTimeout(function () { dock.hidden = true; }, HRC.RM || HRC.paused ? 0 : 380);
}
function check() {
if (shown) return;
var r = W.HRC_DOCK_RULES.evaluate(state(), C);
if (r.show) show(r.reason);
}
HRC.dockState = state; HRC.dockCheck = check;
dock.querySelector('[data-dock-close]').addEventListener('click', function () { close('close'); });
dock.querySelector('[data-dock-later]').addEventListener('click', function () { close('later'); });
dock.querySelector('[data-quiz-open]').addEventListener('click', function () { HRC.track('quiz_invite_start', { page: cfg.page }); close('start'); }, true);
var timer = setInterval(function () { if (shown) { clearInterval(timer); return; } check(); }, 1000);
HRC.on('bag', function () { check(); });
})();